import React from 'react';

import {
	ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE,
	LazyCodeMacroConfigurationPage,
} from '@confluence/site-settings';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminCodeMacroConfigurationRoute = () => <LazyCodeMacroConfigurationPage />;

AdminCodeMacroConfigurationRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
